import { useCallback } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAppDispatch } from '../../../../../../../app/store';
import { contractApi } from '../../../../../../../services/ContractService';
import { ContractView } from '../../../../../../../services/ContractService/types/contractTypes';

/**
 * Hook for managing contract navigation
 */
export function useContractNavigation() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const company = searchParams.get('company') || '';

  const handleRowSelected = useCallback(
    (selectedItem: ContractView) => {
      if (selectedItem?.id) {
        // Invalidate the contract cache to ensure fresh data when switching between contracts
        dispatch(contractApi.util.invalidateTags(['Contract']));

        navigate(
          `/contracts/edit?company=${encodeURIComponent(company)}&id=${encodeURIComponent(
            selectedItem.id
          )}`
        );
      }
    },
    [company, dispatch, navigate]
  );

  const handleCreateContract = useCallback(() => {
    navigate(`/contracts/create?company=${encodeURIComponent(company)}`);
  }, [company, navigate]);

  return {
    company,
    handleRowSelected,
    handleCreateContract,
  };
}
